import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerStyle = {
    backgroundColor: '#1a202c',
    color: '#cbd5e0',
    padding: '3rem 1.5rem',
    textAlign: 'center',
  };

  const contentContainerStyle = {
    maxWidth: '1280px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const logoStyle = {
    fontFamily: 'cursive',
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#80aaff',
    marginBottom: '1rem',
  };

  const navLinksContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '1.5rem',
    marginBottom: '1.5rem',
  };

  const navLinkStyle = {
    color: '#cbd5e0',
    textDecoration: 'none',
    transition: 'color 0.2s ease-in-out',
  };
  
  const socialIconsContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
    marginBottom: '1.5rem',
  };

  const socialIconStyle = {
    backgroundColor: '#2d3748',
    color: '#cbd5e0',
    padding: '0.75rem',
    borderRadius: '50%',
    width: '3rem',
    height: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease-in-out',
  };

  const copyrightStyle = {
    fontSize: '0.875rem',
    color: '#a0aec0',
  };

  return (
    <footer style={footerStyle}>
      <div style={contentContainerStyle}>
        
        {/* Logo */}
        <div style={logoStyle}>Mani Vasu</div>
        
        {/* Navigation Links */}
        <div style={navLinksContainerStyle}>
          <a href="#about" style={navLinkStyle}>About</a>
          <a href="#contact" style={navLinkStyle}>Contact</a>
          <Link to="/privacy" style={navLinkStyle}>Privacy</Link>
          <a href="#terms" style={navLinkStyle}>Terms</a>
        </div>
        
        {/* Social Icons */}
        <div style={socialIconsContainerStyle}>
          <a href="#" style={socialIconStyle} aria-label="Twitter">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1.5rem', height: '1.5rem' }}>
              <path d="M18.2 5.1c-.5.2-1.1.4-1.7.5.6-.4 1-.9 1.2-1.6-.6.4-1.2.6-1.9.8-.6-.6-1.4-.9-2.3-.9-1.7 0-3.1 1.4-3.1 3.1 0 .2 0 .4.1.6-2.6-.1-5-1.4-6.6-3.7-.3.5-.5 1.1-.5 1.7 0 1.1.6 2 1.5 2.5-.5 0-.9-.2-1.4-.4v.1c0 1.5 1.1 2.8 2.6 3-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4-.3 0-.5 0-.8-.1 1.4.9 3.1 1.4 4.8 1.4 5.8 0 9.1-4.8 9.1-9.1v-.4c.6-.4 1.1-.9 1.5-1.5z"/>
            </svg>
          </a>
          <a href="#" style={socialIconStyle} aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1.5rem', height: '1.5rem' }}>
              <path d="M22.2 11.2h-4.3v-2.1c0-1.2.6-1.8 1.8-1.8h2.3V3.4h-3.4c-2.3 0-3.9 1.6-3.9 4.6v3.2h-2.5v3.4h2.5v8.7h4.3v-8.7h3.6l.7-3.4z"/>
            </svg>
          </a>
          <a href="#" style={socialIconStyle} aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1.5rem', height: '1.5rem' }}>
              <path d="M20.2 21.6h-3.9v-7.6c0-1.8-.7-2.9-2.3-2.9-1.2 0-2 .8-2.3 1.6-.2.4-.2.8-.2 1.3v7.6h-3.9s.1-10.6 0-11.7h3.9v1.6c.5-.7 1.3-1.4 2.9-1.4 2.1 0 3.7 1.4 3.7 4.5v7h-4zm-15.6-11.7c1.3 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3-2.3 1-2.3 2.3 1 2.3 2.3 2.3zM2.6 21.6h3.9v-11.7h-3.9v11.7z"/>
            </svg>
          </a>
        </div>
        
        {/* Copyright */}
        <p style={copyrightStyle}>
          © 2023 Mani Vasu. All rights reserved.
        </p>
        
      </div>
    </footer>
  );
};

export default Footer;
